import { enviroment } from "../../enviroment";
import { Form, Page } from "../../core/entities/form";
import { FormDto } from "../dtos/formDto";
import { PageQuery } from "../../core/page-query/models/pageQuery";
import { toFormQueryParam } from "../functions/toFormQueryParam";
import { useAuthHttpClient } from "./useAuthHttpClient";
import { FormMeta } from "../../core/entities/formMeta";
import { mapDtoToForm } from "../dtos/mappers/mapDtoToForm";
import { throwIfNotSuccess } from "./throwIfNotSuccess";

const API_URL = `${enviroment.apiUrl}/api/v1/forms`;

export function useFormService(): FormService {
    const { authFetch } = useAuthHttpClient();

    async function getById(id: string): Promise<Form> {
        const response = await authFetch(`${API_URL}/${id}`);
        throwIfNotSuccess(response);
        const formDto: FormDto = await response.json();
        return mapDtoToForm(formDto);
    }

    async function getAllForms(query: PageQuery): Promise<Page<Form>> {
        const queryString = toFormQueryParam(query);
        const response = await authFetch(`${API_URL}${queryString}`);
        throwIfNotSuccess(response);
        const formDto: Page<FormDto> = await response.json();
        return {
            ...formDto,
            result: formDto.result.map(mapDtoToForm)
        };
    }

    async function getErrorCount(): Promise<FormMeta> {
        const response = await authFetch(`${API_URL}/meta`);
        throwIfNotSuccess(response);
        const formMeta: FormMeta = await response.json();
        return formMeta;
    }

    return {
        getById,
        getAllForms,
        getErrorCount
    };
}

export interface FormService {
    getById(id: string): Promise<Form>;

    getAllForms(query: PageQuery): Promise<Page<Form>>;

    getErrorCount(): Promise<FormMeta>;
}
